<template>
  <div>
    <el-tree
      :data="data"
      :props="props"
      :node-key="nodeKey"
      ref="tree"
      @current-change="currentChangeHandle"
      :default-expand-all="defaultExpandAll"
      :highlight-current="highight"
      :default-expanded-keys="nodeID"
      :show-checkbox="showchenckbix"
      @node-click="handleNodeClick"
      @check-change="handleCheckChange"
    ></el-tree>
  </div>
</template>

<script>
export default {
  name: "treeList",
  props: {
    data: {
      //口数据
      type: Array,
      default: function() {
        return [];
      }
    },
    props: {
      //配置
      type: Object,
      default: function() {
        return {};
      }
    },
    nodeKey: {
      //唯一标识
      type: String,
      default: function() {
        return "";
      }
    },
    showchenckbix: {
      //是否有选择框
      type: Boolean,
      default: function() {
        return false;
      }
    },
    nodeID: {
      //默认选中的数组
      type: Array,
      default: function() {
        return [];
      }
    },
    defaultExpandAll: {
      //是否默认展开所有节点
      type: Boolean,
      default: function() {
        return false;
      }
    },
    currentChangeHandle: {
      //当前选中节点变化时触发的事件
      type: Function,
      default: function() {
        return null;
      }
    },
    highight: {
      //是否高亮显示选中节点
      type: Boolean,
      default: function() {
        return false;
      }
    },
    loading: {
      //魔力圈
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  methods: {
    handleCheckChange() {
      //获取所有被选中的data的数组
      let takeDate = this.$refs.tree.getCheckedNodes();
      this.$emit("check", takeDate);
      //获取所有被选中的key的数组
      let keyDate = this.$refs.tree.getCheckedKeys();
      this.$emit("checkkey", keyDate);
      var ridsa = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.$emit("getMenuIds", ridsa);
    },
    handleNodeClick(data) {
      //点击的时候返回当前点击的key
      // let key = this.$refs.tree.getCurrentKey();
      // let takeDate = this.$refs.tree.getCheckedNodes();
      this.$emit("click", data.deptLevelCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(1);
    });
  }
};
</script>

<style scoped>
.el-tree {
  background: #f0f2f5;
}
</style>
